import React from 'react';
import { remittanceDialogSteps } from './Utils';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import { pathname } from '../../../utils/path/path';
import ButtonCard from '../../BuildingBlocks/Button/ButtonCard';

export default function DialogActions({
  step,
  setStepNumber,
}: {
  step: remittanceDialogSteps;
  setStepNumber: (step: remittanceDialogSteps) => void;
}) {
  const history = useHistory();

  return (
    <>
      {step === remittanceDialogSteps.chooseOption && (
        <div style={{ display: 'block', textAlign: 'center' }}>
          <ButtonCard
            header={'Adjust my Remittance Schedule'}
            subHeader={'e.g. Sales have slowed or sped up'}
            onClick={() => setStepNumber(remittanceDialogSteps.other)}
          />

          <ButtonCard
            header={'Line dates, costs, or units'}
            subHeader={
              'e.g. A shipment delay, increase in freight costs, change to order size, etc.'
            }
            onClick={() => setStepNumber(remittanceDialogSteps.other)}
          />

          <ButtonCard
            header={'Something else'}
            onClick={() => setStepNumber(remittanceDialogSteps.other)}
          />
        </div>
      )}
      {step === remittanceDialogSteps.other && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push(pathname.lines.url)}
        >
          Continue
        </Button>
      )}
    </>
  );
}
